import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'shared/utils/wix-connect';

import { sides, popoutPositions, trianglePositions } from 'shared/constants/popout';

import { sideShape, popoutPositionShape, trianglePositionShape } from 'shared/shapes/popout';

import Icon from 'shared/components/icon/icon';
import Popout from 'shared/components/popout/popout';
import { showTooltip, hideTooltip } from './tooltip-popout';
import { isMobile, isTablet } from 'shared/utils/device/screen';


import styles from './tooltip.styl';


@WixConnect(styles)
export default class Tooltip extends React.Component {

  static propTypes = {
    iconName: React.PropTypes.string,
    preventHideOnHover: React.PropTypes.bool,
    noTooltip: React.PropTypes.bool,
    popoutComponent: React.PropTypes.func,
    popoutSide: sideShape,
    popoutPosition: popoutPositionShape,
    trianglePosition: trianglePositionShape,
    className: React.PropTypes.string,
    popoutClassName: React.PropTypes.string,
    popoutTriangleClassName: React.PropTypes.string,
    popoutInnerClassName: React.PropTypes.string,
    getRef: React.PropTypes.func,
    onTooltipShow: React.PropTypes.func,
    text: React.PropTypes.any,
    children: React.PropTypes.any,
  };

  static defaultProps = {
    iconName: 'info',
    preventHideOnHover: false,
    noTooltip: false,
    popoutComponent: Popout,
    popoutSide: sides.RIGHT,
    popoutPosition: popoutPositions.CENTER,
    trianglePosition: trianglePositions.CENTER,
    getRef: _.noop,
    onTooltipShow: _.noop,
  };

  componentWillUpdate(nextProps) {
    const { noTooltip } = nextProps;
    if (noTooltip !== this.props.noTooltip) {
      if (noTooltip) {
        this.hideTooltipPopout();
      } else {
        this.showTooltipPopout();
      }
    }
  }

  @autobind
  showTooltipPopout() {
    const {
      popoutSide, popoutPosition, trianglePosition,
      preventHideOnHover, popoutComponent, popoutClassName,
      popoutTriangleClassName, popoutInnerClassName, text, noTooltip, children,
      onTooltipShow,
    } = this.props;

    if (noTooltip) {
      return;
    }

    showTooltip({
      preventHideOnHover,
      popoutComponent,

      popoutSide,
      popoutPosition,
      trianglePosition,

      className: popoutClassName,
      innerClassName: popoutInnerClassName,
      triangleClassName: popoutTriangleClassName,

      content: text || children,
      referenceElement: this.icon,

      ...this.tooltipPropsForDevice,
    });

    onTooltipShow();
  }

  hideTooltipPopout() {
    hideTooltip();
  }

  @autobind
  getRef(node) {
    this.icon = node;
    this.props.getRef(node);
  }

  get behaviorProps() {
    if (isMobile() || isTablet()) {
      return {
        onTouchStart: this.showTooltipPopout,
      };
    }

    return {
      onMouseEnter: this.showTooltipPopout,
      onMouseLeave: this.hideTooltipPopout,
    };
  }

  get tooltipPropsForDevice() {
    if (isMobile() || isTablet()) {
      return {
        onClickOutside: this.hideTooltipPopout,
      };
    }

    return {};
  }

  render() {
    const { iconName, className } = this.props;

    return (
      <Icon getRef={this.getRef}
            name={iconName}
            styleName="icon"
            className={className}
            onClick={this.showTooltipPopout}
            {...this.behaviorProps} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/tooltip/tooltip.js